import { render, staticRenderFns } from "./ProductHcAdd.vue?vue&type=template&id=449a9556&"
import script from "./ProductHcAdd.vue?vue&type=script&lang=js&"
export * from "./ProductHcAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductHcAdd.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports